import { Component, Inject, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { BdcUnitResponse } from '@tokeet-frontend/channel-content'
import { BehaviorSubject } from 'rxjs'
import { BdcPropertyUnitDetailsComponent } from './bdc-property-unit-details/bdc-property-unit-details.component'
import { BdcPropertyUnitAmenitiesComponent } from './bdc-property-unit-amenities/bdc-property-unit-amenities.component'
import { BdcPropertyUnitLicenseComponent } from './bdc-property-unit-license/bdc-property-unit-license.component'
import { BdcPropertyUnitGalleryComponent } from './bdc-property-unit-gallery/bdc-property-unit-gallery.component'
import { BdcPropertyUnitBathroomComponent } from './bdc-property-unit-bathroom/bdc-property-unit-bathroom.component'
import { isSomething } from '@tokeet-frontend/tv3-platform'
export enum BdcPropertyUnitDialogTab {
  Details,
  Amenities,
  Licenses,
  Gallery,
  Bathrooms,
}
@Component({
  selector: 'app-bdc-property-unit-dialog',
  templateUrl: './bdc-property-unit-dialog.component.html',
  styleUrls: ['./bdc-property-unit-dialog.component.scss'],
})
export class BdcPropertyUnitDialogComponent {
  @ViewChild('details') details: BdcPropertyUnitDetailsComponent
  @ViewChild('amenities') amenities: BdcPropertyUnitAmenitiesComponent
  @ViewChild('licenses') licenses: BdcPropertyUnitLicenseComponent
  @ViewChild('gallery') gallery: BdcPropertyUnitGalleryComponent
  @ViewChild('bathroom') bathroom: BdcPropertyUnitBathroomComponent

  tab$ = new BehaviorSubject<BdcPropertyUnitDialogTab>(BdcPropertyUnitDialogTab.Details)
  tabs = BdcPropertyUnitDialogTab

  get unit() {
    return this.data?.unit
  }
  get propertyId() {
    return this.data?.propertyId
  }
  get propertyTypeId() {
    return this.data?.propertyTypeId
  }

  isEdit = false
  constructor(
    public dialogRef: MatDialogRef<BdcPropertyUnitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { unit?: BdcUnitResponse; propertyId: number; propertyTypeId: number }
  ) {
    this.isEdit = isSomething(this.data?.unit)
  }

  close() {
    this.dialogRef.close()
  }
}
